import { useDocumentSnapshot } from './useDocumentSnapshot';
import { Collections } from '../collections';
import { User } from '../documents/user';

export const useUserDocumentSnapshot = (userId?: string): User | undefined => {
  return useDocumentSnapshot<User>(Collections.USERS, userId);
};
